export interface FeatureFlagInfo {
  flagName: string;
}

export const FEATURE_FLAG_MAP = {
  SCHEDULER_V3_UI: {
    flagName: 'scheduler-v3-ui',
  },
  OPERATORY_V3: {
    flagName: 'schedule:operatory-v3',
  },

  SCHEDULE_WAITLIST_DIRECT_SCHEDULING: {
    flagName: 'schedule:waitlist:direct_scheduling',
  },
  SCHEDULE_CALENDAR_BLOCK_UI: {
    flagName: 'schedule:calendar-block-ui',
  },
  SCHEDULE_CALENDAR_COLUMNS_REORDERING: {
    flagName: 'schedule-calendar-columns-reordering',
  },
  SCHEDULE_CALENDAR_APPOINTMENTS_REORDERING: {
    flagName: 'schedule:calendar-appointments-reordering',
  },
  SCHEDULE_CALENDAR_EXPAND_COLLAPSE: {
    flagName: 'schedule:calendar-expand-collapse',
  },
  SCHEDULE_REQUESTS_WIDGET: {
    flagName: 'schedule:requests-widget-v3',
  },
  SERVICE_TYPES_V3: {
    flagName: 'schedule-definitions',
  },
  SCHEDULE_CALENDAR_REQUEST_EVENTS_V3: {
    flagName: 'schedule:calendar-request-events-v3',
  },
} as const satisfies Record<string, FeatureFlagInfo>;

export type FeatureFlagKey = keyof typeof FEATURE_FLAG_MAP;
